import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquareText } from 'lucide-react';
export function FloatingQuoteButton() {
  return <div className="hidden lg:block fixed bottom-6 right-6 z-40" data-id="element-47">
      <motion.a href="#quote" className="flex items-center gap-2 bg-brand-red hover:bg-brand-redDark text-white px-6 py-4 rounded-full shadow-xl font-bold uppercase tracking-wide transition-colors border-2 border-white" whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} animate={{
      boxShadow: ['0px 0px 0px 0px rgba(200, 16, 46, 0.4)', '0px 0px 0px 15px rgba(200, 16, 46, 0)']
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-48">
        <MessageSquareText className="w-5 h-5" data-id="element-49" />
        <span data-id="element-50">Get a Free Quote</span>
      </motion.a>
    </div>;
}